import { shallowRef } from "vue";
import { defineStore } from "pinia";

export const useModalStore = defineStore("modal", {
    state: () => {
        return {
            isOpen: false,
            component: null,
            componentProps: null,
        };
    },
    actions: {
        open(component, props) {
            if(!component) {
                console.warn('No component passed.')
            }
            this.componentProps = props;
            this.component = shallowRef(component);
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
        }
    },
});
